import React, { memo } from 'react'
import { TextBody, Link } from '@ally/metronome-ui'
import { getSlashDate } from '../../utils/formatter'

interface PropsTypes {
  riskLevel: number
  actionDate: string
}

export const CoverDraftNotification: React.FC<PropsTypes> = memo(props => {
  const { riskLevel, actionDate } = props
  const actionDateToShow = getSlashDate(actionDate)
  const lowRiskMessage = `You can't make any new purchases or withdrawals right now because you have a negative balance. We need you to add money to cover it by ${actionDateToShow}, or we may close your account. `
  const highRiskMessage = `You need to add money to cover your negative balance by ${actionDateToShow}, or we may close your account. `
  return (
    <TextBody size="sm" tag="p" data-testid="coverDraftRiskNotification">
      {riskLevel === 1 ? lowRiskMessage : highRiskMessage}
      <Link to="/payments/transfers" text="Transfer money" />
    </TextBody>
  )
})
